"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        headerCell: {
            display: 'flex',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(1), "px"),
            fontWeight: 700,
            borderRadius: 0,
            borderTopLeftRadius: 5,
            backgroundColor: '#fff',
            borderTop: '1px solid #ECEBEA',
            borderLeft: '1px solid #ECEBEA',
            borderBottom: '1px solid #ECEBEA',
            borderRight: '1px solid #ECEBEA',
            color: theme.palette.text.secondary,
            height: 45,
        },
        title: {
            flexGrow: 1,
        },
        columnMoreOptions: {
            cursor: 'pointer',
            position: 'relative',
        },
        moreButton: {
            padding: 0,
            minWidth: 'auto',
        },
        menuIcon: {
            minWidth: 34,
        },
    });
});
